export const GET_INVOICES = 'GET_INVOICES'
export const GET_INVOICE = 'GET_INVOICE'
export const ADD_INVOICE = 'ADD_INVOICE'
export const UPDATE_INVOICE = 'UPDATE_INVOICE'
export const DELETE_INVOICE_IN_BULK = 'DELETE_INVOICE_IN_BULK'
export const DELETE_INVOICE_BY_ID = 'DELETE_INVOICE_BY_ID'
export const INVOICE_REPORT = 'INVOICE_REPORT'
